<template>
	<section>
		<filtros :filter_data="filter_data" @filtrar="filtrar" />

		<table class="table table-striped table-sm">
			<thead align="center">
				<th @click="orderBy('id')">ID <font-awesome-icon v-if="direction.by == 'id'" :icon="order_icon" size="xs" /></th>
				<th @click="orderBy('data')">DATA <font-awesome-icon v-if="direction.by == 'data'" :icon="order_icon" size="xs" /></th>
				<th @click="orderBy('hora')">HORA <font-awesome-icon v-if="direction.by == 'hora'" :icon="order_icon" size="xs" /></th>
				<th @click="orderBy('origem')">ORIGEM <font-awesome-icon v-if="direction.by == 'origem'" :icon="order_icon" size="xs" /></th>
				<th>UNIDADE</th>
				<th>ÁUDIO</th>
				<th>DOWNLOAD</th>
			</thead>

			<transition mode="out-in" name="leftIn">
				<tbody v-if="elogios" align="center">
					<tr v-for="(elogio, index) in elogios.result.data" :key="index">
						<td>{{ elogio.id }}</td>
						<td>{{ elogio.data }}</td>
						<td>{{ elogio.hora }}</td>
						<td>{{ Phone(elogio.origem) }}</td>
						<td>{{ get_unidade_name(elogio.unidade_id) }}</td>
						<td><font-awesome-icon icon="volume-up" class="info pointer" @click="audio_play(elogio)"/></td>
						<td><font-awesome-icon icon="download" class="info pointer" @click="audio_down(elogio.id)" /></td>
					</tr>

				</tbody>
				<div v-else>
					<Loading />
				</div>
			</transition>
		</table>
		<controls :data="constrol_data" @refresh="navigate" @alert="show_alert" />
		<modal :sac="modal_data" />
	</section>
</template>

<script>
import api from "@/mixins/api.js"
import replace from "@/mixins/replace.js"
import pdfBtn from "@/components/Tools/Pdf.vue"
import filtros from "@/components/Tools/Filtro.vue"
import controls from "@/components/Tools/Table_Control.vue"
import player from "@/components/Tools/Player"
import modal from "@/components/Modal/playAudioSAC"
import alert from "@/components/Tools/alert.vue"
import { EventBus } from '@/event-bus.js';


export default {
	name: "elogios",
	props: ["table", "method"],
	mixins: [api, replace],
	components: { controls, filtros, alert, pdfBtn, player, modal },

	data() {
		return {
			elogios: null,

			constrol_data: {},
			modal_data: {},
			looping: null,
			timestamps: true,

			alert: { type: "", msg: "" },

			direction: { order: "desc", by: "id" },

			pagination: "10?",
			string_filter: "",

			filter_data: [
				{
					name: "id",
					label: "ID",
					type: "text",
					data_get: ""
				},

				{
					name: "data",
					label: "Data",
					type: "date",
					data_get: ""
				},

				{
					name: "origem",
					label: "Origem",
					type: "phone",
					data_get: ""
				},

				// Adiciona o campo apenas se for super admin
				...(this.$store.state.user.type == 3 ? [{
						name: "unidade_id", 
						label: "Unidade", 
						type: "select", 
						data_get: "Unidade" 
					}] : [])

			],

			selectedUnit: 0

		}
	},

	created() {
		this.get_data();
		this.get_unidades()
		EventBus.$on('unit-changed', this.onUnitChanged)

	},

	computed: {
		ordenation() {
			return `order=${this.direction.order}&by=${this.direction.by}`;
		},

		order_icon() {
			return (this.direction.order == "asc") ? "arrow-up" : "arrow-down";
		}
	},

	beforeDestroy() {
        EventBus.$off('unit-changed', this.onUnitChanged);
    },


	methods:
	{
		async get_unidades() {
			this.unidades = await this.GET("Unidade")
		},

		get_unidade_name(payload) {
			if (this.unidades) {
				for (var i = 0; i <= this.unidades.result.length - 1; i++) {
					if (this.unidades.result[i].id == payload) {
						return this.unidades.result[i].nome
					}
				}
			}
		},

		orderBy(payload) {
			if (payload == this.direction.by) {
				this.direction.order = (this.direction.order == 'desc') ? 'asc' : 'desc';
			} else {
				this.direction.by = payload;
			}

			this.get_data();
		},

		filtrar(payload) {
			this.string_filter = payload;
			this.get_data();
		},

		is_super_adm() {
            const selectedUnit = this.selectedUnit;
            if (this.$store.state.user.type !== 3) {
                return "&unidade_id=" + this.$store.state.user.unidade_id;
            } else if (selectedUnit !== 0) {
                return "&unidade_id=" + selectedUnit;
            } else {
                return "";
            }
        },

		onUnitChanged(unitId) {
            this.selectedUnit = unitId;
            this.get_data();
        },

		async get_data() {
			this.elogios = null;
			var unidade_filtro = this.is_super_adm()
			this.elogios = await this.GET("SAC", `Elogios/Paginate/${this.pagination}${this.ordenation}${this.string_filter}${unidade_filtro}`);

			this.constrol_data = {
				current_page: this.elogios.result.current_page,
				last_page: this.elogios.result.last_page,
				per_page: this.elogios.result.per_page,
				total: this.elogios.result.total,
			}

			if (this.timestamps) {
				this.refresh();
			} else {
				clearTimeout(this.looping);
			}
		},

		refresh() {
			clearTimeout(this.looping);
			this.looping = setTimeout(() => this.get_data(), 80000);
		},

		audio_play(payload) {
			this.modal_data = payload;
			$("#modal-playAudio").modal('show');
		},

		navigate(payload) {
			this.pagination = payload;
			this.get_data();
		},

		show_alert(payload) {
			this.alert.type = (payload.status == "success") ? "alert-success" : "alert-danger";
			this.alert.msg = payload.result;
			$("#modal-playAudio").modal('hide');
			this.get_data();
			$("#app-alert").show();
			setTimeout(() => $("#app-alert").hide(), 3000);
		},


		convert_hor(payload) {
			var nova_hora = new Date(payload);
			nova_hora.setHours(nova_hora.getHours() - 3);
			return nova_hora;
		},

		async audio_down(id_sac) {
			var resposta = await this.GET("SAC/download", id_sac);
			var nome_audio = 'ELOGIO_ID_' + id_sac + '.wav';
			var fileURL = window.URL.createObjectURL(new Blob([resposta]));
			var fileLink = document.createElement('a');
			fileLink.href = resposta;
			fileLink.setAttribute('download', nome_audio);
			document.body.appendChild(fileLink);
			fileLink.click();
		},

		convert_hor(payload) {
			var nova_hora = new Date(payload);
			nova_hora.setHours(nova_hora.getHours() - 3);
			return nova_hora;
		},

	},

	beforeRouteLeave(to, from, next) {
		this.timestamps = false;
		EventBus.$emit('reset-unit-filter');
		next();
	},
}

</script>